import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
import ConfirmationForm from '../../components/checkout-steps/confirmation-form';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import APP_ROUTES from '../../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    placedOrder: state.placedOrder,
    stores: state.stores.stores,
    locale: state.locale,
    currentZone: state.zones.currentZone,
    hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
    gracePeriod: state.cartState.gracePeriod,
    orderError: state.placedOrder.orderError,
    showDialogError: state.placedOrder.showDialogError,
});

const mapDispatchToProps = (dispatch) => ({
    handleCheckoutStepNotEditable: (order, placedOrder) => {
        /* Redirect to last step if order is already placed */
        if (placedOrder.id) {
            dispatch(push(APP_ROUTES.checkout[`${placedOrder.checkout_steps.slice(-1)}PageRoute`]));
        } else if (order.id) {
            const previousStep = CheckoutStepCalculator.previous(order.checkout_steps, 'confirm');

            dispatch(push(APP_ROUTES.checkout[`${previousStep}PageRoute`]));
        } else {
            dispatch(push(APP_ROUTES.cartPageRoute));
        }
    },

    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'confirm',
        });
    },

    handleFormSubmit: (formData, order, locale) => dispatch(Actions.goToNextStep(order, locale, formData)),

    redirectToCart: () => dispatch(push(APP_ROUTES.cartPageRoute)),

    onHideDialogError: () => {
        dispatch({
            type: APP_ACTIONS.COMPLETE_ORDER_ERROR_HIDE_DIALOG,
        });
    },
});

const CheckoutConfirmationConnector = connect(mapStateToProps, mapDispatchToProps)(ConfirmationForm);

export default CheckoutConfirmationConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/confirmation-form-connector.js
 **/